import Vue from 'vue'

export default {

	props: ['values'],

	data: function() {

		return {
            stayAfterSave: false,
            defaultValues: false,
			is: {
				valid: false,
				changed: false,
				errored: false,
				submitting: false,
				saved: false
			},
			errored: {}
		}

	},

	watch: {

		inputs: {

			deep: true,

			handler: function() {

				this.onInputsChange()

			}

		}

	},

	created: function() {

        this.defaultValues = this.$_.clone(this.inputs)

        this.resetValues()
        this.onInputsChange()

        this.$on('preloaded', this.onPreload.bind(this))

    },
    
    beforeDestroy: function() {

        this.$off('preloaded', this.onPreload.bind(this))

    },

	methods: {

		save: function(action, params) {

            this.is.submitting = true
            
            if (this.preload) {

                params.id = this.defaultValues.id

            }

			return new Promise(function(resolve, reject) {

				this.$api.request(action, params).then(function(json) {

					this.is.saved = true

					if (this.stayAfterSave) {

						this.is.errored = false
						this.is.submitting = false

						Vue.set(this, 'errored', {})

						this.resetValues()

					}

					resolve(json)

				}.bind(this), function(e) {

					this.is.submitting = false
					this.is.errored = true
					this.is.saved = false

					this.errored = {}

					this.$_.each(e.inputs, function(value, key) {

						Vue.set(this.errored, key, true)

					}.bind(this))

					reject()

				}.bind(this))

			}.bind(this))

		},

		resetValues: function() {

			var values = this.values || this.defaultValues
			var rules

			this.$_.each(values, function(value, key) {

				rules = this.rules[key] || {}

				this.inputs[key] = (!rules.password) ? value : ''

			}.bind(this))

			this.is.changed = false

		},

		onInputsChange: function() {

			this.is.valid = this.$_.every(this.rules, function(rules, input) {

				var value = this.inputs[input]

				return this.$_.every(rules, function(rule, type) {

					if (type === 'required' && rule) {

						return (value) ? true : false

					} else if(type === 'minlength') {

						return value.length >= rule

					} else if(type === 'match') {

						return value === this.inputs[rule]

					}

					return true

				}.bind(this))

			}.bind(this))

			this.$emit('changed', this.inputs)

        },
        
        onPreload: function(values) {

            this.defaultValues = values
            this.resetValues()
            this.onInputsChange()

        }

	}

}